import request from '../../axios';

const PatchToolRequirement = async (
  payload: IToolRequirementPayload,
  guid?: string,
) => {
  const newPayload = {
    title: payload.title,
    ad_type: payload.ad_type,
    sub_input: payload.sub_input?.guid,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    wanted_number: payload?.wanted_number,
    brs_type: payload.srs_type?.type,
    only_massage_buyer: payload.only_massage_buyer || false,
    is_change_title: payload?.is_change_title,
    filter: 'advertisement',
  };
  const response = await request.patch(`api/v2/store/advertisement/${guid}`, {
    ...newPayload,
  });

  return response.data;
};

export default PatchToolRequirement;
